import { z } from 'zod'

import { nanoidSchema } from '@scalar-org/entities/utility'

import { type Icon, iconSchema, titleSchema } from '@/schema/utility'

// ---------------------------------------------------------------------------

/** Example link navigation entry. */
const _exampleLink: LinkNavigationEntry = {
  type: 'link',
  url: 'https://www.google.com',
  title: 'Google',
  icon: 'phosphor/icon-globe',
}

export type LinkNavigationEntry = {
  type: 'link'
  url: string
  title?: string
  icon?: Icon
  newTab?: boolean
}

// ---------------------------------------------------------------------------
export const linkNavigationEntrySchema = z.object({
  type: z.literal('link'),
  /** The URL to link to. */
  url: z.string().describe('The URL to link to.'),
  title: titleSchema.optional(),
  /** Optional icon to show beside the link. */
  icon: iconSchema.optional(),
  newTab: z.boolean().optional(),
}) satisfies z.ZodType<LinkNavigationEntry>

export type InternalLinkNavigationEntry = LinkNavigationEntry & { uid: string }

export const internalLinkNavigationEntrySchema =
  linkNavigationEntrySchema.extend({
    uid: nanoidSchema,
  }) satisfies z.ZodType<InternalLinkNavigationEntry>
